import ENGLISH_FLAG from './flags/gb.png'
import GREEK_FLAG from './flags/gr.png'
import IMAGE_NOT_FOUND from './imageNotFound.jpg'
import LOGO from './logo/logo.png'
import PROMO from './logo/logo.png'

const Images = {
	logo: LOGO,
	imageNotFound: IMAGE_NOT_FOUND,
	englishFlag: ENGLISH_FLAG,
	greekFlag: GREEK_FLAG,
	promo: PROMO
}

export default Images